import styled from 'styled-components'

export const Bar = styled.div`
  height: 6px;
  background: #eee;
  border-radius: 3px;
  margin-top: 6px;
`

export const Progress = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  height: 100%;
  background: #18b5df;
  border-radius: 3px;
`
